
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TrackerTableItem',
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
})
